import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, type Expense, type ExpenseStatus } from "../api";
import { fmtDate } from "../ui";

const TABS: { k: ExpenseStatus | "all" | "mine"; label: string }[] = [
  { k: "all",                label: "Toutes" },
  { k: "submitted",          label: "À traiter" },
  { k: "taken_into_account", label: "Prises en compte" },
  { k: "rejected",           label: "Rejetées" },
  { k: "mine",               label: "Les miennes" },
];

const LABEL: Record<ExpenseStatus, string> = {
  submitted:          "Soumise",
  taken_into_account: "Prise en compte",
  rejected:           "Rejetée",
};

const BADGE_CLASS: Record<ExpenseStatus, string> = {
  submitted:          "review",
  taken_into_account: "validated",
  rejected:           "pending",
};

export default function Expenses() {
  const [items, setItems] = useState<Expense[]>([]);
  const [tab, setTab] = useState<(typeof TABS)[number]["k"]>("submitted");

  const load = useCallback(async () => {
    const q = new URLSearchParams();
    if (tab === "mine") q.set("mine", "1");
    else if (tab !== "all") q.set("status", tab);
    const r = await api<{ expenses: Expense[] }>(`/expenses?${q}`);
    setItems(r.expenses);
  }, [tab]);

  useEffect(() => { load(); }, [load]);

  return (
    <>
      <div className="row spread">
        <h2 style={{ margin: 0 }}>Notes de frais</h2>
        <Link to="/expenses/new" className="btn btn-primary sm">+ Note</Link>
      </div>

      <div className="tabs">
        {TABS.map((t) => (
          <button key={t.k} className={tab === t.k ? "active" : undefined} onClick={() => setTab(t.k)}>
            {t.label}
          </button>
        ))}
      </div>

      <div className="doc-list">
        {items.map((e) => (
          <Link key={e.id} to={`/expenses/${e.id}`} className="card tap doc-row">
            <div className="title">{e.label}</div>
            <div className="meta">
              <span className="entity-chip">{e.entity_code}</span>
              <span className={`badge ${BADGE_CLASS[e.status]}`}>{LABEL[e.status]}</span>
              <span className="tiny">
                {(e.amount_cents / 100).toFixed(2)} {e.currency}
              </span>
              <span className="tiny">· {e.user_identifier} · {fmtDate(e.expense_date)}</span>
            </div>
          </Link>
        ))}
        {items.length === 0 && <p className="muted">Aucune note dans cette catégorie.</p>}
      </div>
    </>
  );
}
